import React, { ReactNode, useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { IFreelancer } from "../../data_models/freelancer";
import { TbProgress, TbTargetArrow } from "react-icons/tb";
import { MdTaskAlt } from "react-icons/md";
import { GrMoney } from "react-icons/gr";
import { PiProjectorScreenChartLight } from "react-icons/pi";
import { RiTaskLine } from "react-icons/ri";



const FreelancerDashboardOverview = () => {

    const { currentUser } = useCurrentUser();
    const [completedProjects, setCompletedProjects] = useState<number>(0);

    const [completedTasks, setCompletedTasks] = useState(0);
    const [ongoingTasks, setOngoingTasks] = useState(0);
    const [completedProjectManagements, setCompletedProjectManagements] = useState(0);
    const [ongoingProjectManagements, setOngoingProjectManagements] = useState(0);

    useEffect(() => {
        setCompletedTasks((currentUser as IFreelancer)?.platformCompletedJobs?.length || 0);
        setOngoingTasks((currentUser as IFreelancer)?.platformCurrentJobs?.length || 0);
        setCompletedProjectManagements((currentUser as IFreelancer)?.platformCompletedProjectManagements?.length || 0);
        setOngoingProjectManagements((currentUser as IFreelancer)?.platformCurrentProjectManagements?.length || 0);

        let projects = 0;
        const projectIdSet = new Set();
        for (const p of (currentUser as IFreelancer)?.platformCompletedJobs || []) {
            if (!projectIdSet.has(p.projectId)) {
                projectIdSet.add(p.projectId);
                projects++;
            }
        }
        setCompletedProjects(projects);
    }, []);

    return (
        <div className="">
            <p className="body1 font-bold">Overview</p>
            <div className="flex flex-wrap gap-4">

                <OverviewCard
                    number={completedProjects}
                    title="Projects"
                    icon={<TbTargetArrow className="w-12 h-12" />} />

                <OverviewCard
                    number={ongoingTasks}
                    title="Ongoing Tasks"
                    icon={<TbProgress className="w-12 h-12" />} />

                <OverviewCard
                    number={completedTasks}
                    title="Completed Tasks"
                    icon={<MdTaskAlt className="w-12 h-12" />} />

                {ongoingProjectManagements > 0 && <OverviewCard
                    number={ongoingTasks}
                    title="Ongoing Project Management"

                    icon={<PiProjectorScreenChartLight className="w-12 h-12" />} />}

                {completedProjectManagements > 0 && <OverviewCard
                    number={ongoingTasks}
                    title="Completed Project Management"

                    icon={<RiTaskLine className="w-12 h-12" />} />}

            </div>
        </div >
    );
};


interface OverviewCardProps {
    number: number;
    title: string;
    icon: ReactNode;
    caption?: string;
    captionIcon?: ReactNode;
}


const OverviewCard: React.FC<OverviewCardProps> = ({ number, title, icon, caption, captionIcon }) => {

    return <div className="border border-neutral-200 rounded-lg w-72 h-52 p-6 flex flex-col">
        <div className="flex flex-row justify-between items-center">
            <h2 className="font-bold text-secondary-300">{number}</h2>
            <div className="flex justify-center items-center bg-secondary-100 w-14 h-14 rounded-full">
                {icon}
            </div>
        </div>
        <div className="mt-auto">
            <p className="body2">{title}</p>

        </div>
    </div >;
};



export default FreelancerDashboardOverview;